'use strict';

export default class Utility {

  static hex2rgba(hex, opacity) {
    opacity = parseFloat(opacity);
    hex = hex.replace('#', '');
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);

    return `rgba(${r},${g},${b},${opacity})`;
  }

  static isIframeMap() {
    return document.body.classList.contains('twer-page-iframe-map');
  }

  static isEmpty(value) {
    if (Array.isArray(value)) {
      return value.length === 0;
    } else if (typeof value === 'object' && value !== null) {
      return Object.keys(value).length === 0;
    } else {
      throw new Error('Parameter must be an array or object');
    }
  }


  static calcOffsetCoords(options) {
    const {latlng, offsetx, offsety, map} = options;
    var scale = Math.pow(2, map.getZoom());

    var worldCoordinateCenter = map.getProjection().fromLatLngToPoint(latlng);
    var pixelOffset = new google.maps.Point((offsetx / scale) || 0, (offsety / scale) || 0);

    var worldCoordinateNewCenter = new google.maps.Point(
      worldCoordinateCenter.x + pixelOffset.x,
      worldCoordinateCenter.y + pixelOffset.y
    );

    return map.getProjection().fromPointToLatLng(worldCoordinateNewCenter);
  }

  static stripCoordinates(number) {
    return number.toString().match(/^-?\d+(?:\.\d{0,7})?/)[0];
  }

  static isTouchDevice() {
    return 'ontouchstart' in document.documentElement || 'ontouchstart' in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
  }

  static stripToFixed(number, fixed) {
    const isInteger = Number.isInteger(number);

    if (isInteger) {
      return number.toString();
    }
    return number.toFixed(fixed);
  }

  static toggleClasses(element, classesToRemove, classesToAdd) {
    element.classList.remove(...classesToRemove);
    element.classList.add(...classesToAdd);
  }

  static toCamelCaseFromDash(str) {

    return str.split('-').map((word, index) => {

      if (index === 0) {
        return word;
      }

      return word[0].toUpperCase() + word.slice(1);
    }).join('');
  }
}
